import { useEffect } from "preact/hooks";
import type { Upload } from "@campaign-media/shared";

interface Props {
  items: Upload[];
  index: number;
  urlFor: (path: string) => string;
  onClose: () => void;
  onPrev: () => void;
  onNext: () => void;
}

export function Lightbox({ items, index, urlFor, onClose, onPrev, onNext }: Props) {
  const item = items[index];

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, onPrev, onNext]);

  if (!item || !item.storage_path) return null;
  return (
    <div class="lightbox" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <button class="close" onClick={onClose} aria-label="Close">&times;</button>
      <button class="nav prev" onClick={onPrev} aria-label="Previous">&#8249;</button>
      <img src={urlFor(item.storage_path)} alt="" />
      <button class="nav next" onClick={onNext} aria-label="Next">&#8250;</button>
      {item.caption && <div class="lb-caption">{item.caption}</div>}
    </div>
  );
}
